// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tp-wrapper{pointer-events:none;position:absolute;text-align:center;bottom:10%;width:100%;background:rgba(0,0,0,.5);box-shadow:0 0 20px rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;flex-direction:column}.tp-url{margin-top:10px;width:380px!important;height:240px!important;-o-object-fit:cover;object-fit:cover}.tp-name{color:#fff;font-size:20px;font-size:30px;margin-bottom:15px;margin-top:15px}", ""]);
// Exports
module.exports = exports;
